import React, { useContext, useState } from 'react';
import { ModalContext, EditorContext, PluginsEventsContext } from 'ricos-context';
import { SETTINGS_TAB } from '../constants.js';
import { SettingsModalContent } from './SettingsModalContent.js';
import 'ricos-schema';
import '../types.js';
import '@wix/design-system';
import 'ricos-styles';
import 'wix-rich-content-common';
import 'wix-rich-content-editor-common';
import 'wix-rich-content-ui-components';
import '../style-inject.es-e7b07dd7.js';
import '../components/design-component.js';
import '../dataHooks.js';
import '../utils/resolve-colors.js';
import '../defaults.js';
import '../components/settings-component.js';
import 'ricos-content';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ButtonSettingsModal = ({ nodeId, settings, type, modalId, activeTab: tab }) => {
  const modalService = useContext(ModalContext) || {};
  const { getEditorCommands } = useContext(EditorContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const [initialData] = useState(
    () => getEditorCommands().getBlockComponentData(nodeId)
  );
  const [componentData, setComponentData] = useState(
    () => getEditorCommands().getBlockComponentData(nodeId)
  );
  const [activeTab, setActiveTab] = useState(tab != null ? tab : SETTINGS_TAB.SETTINGS);
  const handleOnChange = (data) => {
    setTimeout(() => {
      getEditorCommands().setBlock(nodeId, type, __spreadProps(__spreadValues(__spreadValues({}, componentData), data), {
        id: nodeId
      }));
    }, 0);
    setComponentData(__spreadValues(__spreadValues({}, componentData), data));
  };
  const closeModal = () => {
    modalService.closeModal(modalId);
  };
  const handleOnSave = () => {
    closeModal();
  };
  const handleOnCancel = () => {
    handleOnChange(initialData);
    closeModal();
  };
  const helpers = {
    onPluginAction: (_, _a) => {
      var _b = _a, { plugin_id } = _b, params = __objRest(_b, ["plugin_id"]);
      return pluginsEvents.publishPluginLinkable(__spreadValues({ pluginId: plugin_id, nodeId }, params));
    }
  };
  return componentData ? /* @__PURE__ */ React.createElement(
    SettingsModalContent,
    {
      buttonData: componentData,
      helpers,
      config: settings,
      onCloseRequested: closeModal,
      onChange: handleOnChange,
      onSave: handleOnSave,
      onCancel: handleOnCancel,
      nodeId,
      activeTab,
      onTabChange: setActiveTab
    }
  ) : null;
};

export { ButtonSettingsModal as default };
//# sourceMappingURL=SettingsModal.js.map
